module.exports = __webpack_public_path__ + "yz/img/宅急送.90e75e2a.jpeg";